const caseNotificationButtonStyle = {
  notificationButton: {
    marginRight: "5px"
  }
};

export default caseNotificationButtonStyle;
